import {
  GET_USERINFO,
  RECORD_USERINFO,
  DISPLAYHIDING_LOGININFO,
  RECORD_STATE,
  REMOVE_USERINFO,
  DISPLAYHIDING_ACCOUNT,
  RESET_SDPHASE,
  CHANGE_LOADING,
  ADD_DELIVERY,
  EDIT_ORDER,
  ADD_SEX,
  ADD_CATEGORY,
  ADD_STYLE,
  ADD_FABRICSUPPLY,
  CHANGE_DESIGN,
  CHANGE_DESIGNCOPY,
  CHANGE_DEFAULTFABRIC,
  ADD_SAVEUSERDATA,
  ADD_SDPHASETYPE,
  ADD_SELFMASSING,
  ADD_SELFDETERMINATION,
  CHANGE_WD_DESIGN,
  ADD_WD_FABRICSUPPLY,
  ADD_GOODS,
  CHANGE_LANG,
  CHANGE_3D,
  ALL_MSG,
  GD_END,
  GD_INFO,
  GD_RELATION,
  CHANGE_IMG,
  RECORD_WD_STATE,
  CONTENT_AREA,
  CONTENT_FLAG,
  CONTENT_DESIGN,
  DRAWER_NAME,
  GLOBAL_FLAG,
  EDIT_COMMODITY,
  ADD_EDITIONTYPE,
  ADD_PROCESSLIST,
  CLEAR_CACHETDCIDS,
  IS_STEP
} from './mutation-types'
import { setStore, getStore } from '../utils/storage'
let that = null;

export default {
  // 信息获取session
  [RECORD_STATE](state, info) {
    console.log(JSON.parse(info.info));
    state.userInfo = JSON.parse(info.info).userInfo;
    state.login = JSON.parse(info.info).login;
    state.sdphase1 = JSON.parse(info.info).sdphase1;
    state.sdphase2 = JSON.parse(info.info).sdphase2;
    state.sdphase3 = JSON.parse(info.info).sdphase3;
    // state.saveUserData = JSON.parse(info.info).saveUserData;
    state.editCommodity = JSON.parse(info.info).editCommodity
    state.selfMassing = JSON.parse(info.info).selfMassing;
    state.selfDetermination = JSON.parse(info.info).selfDetermination;
    state.sdphaseType = JSON.parse(info.info).sdphaseType;
    state.selectOrderList = JSON.parse(info.info).selectOrderList;
    state.wdfabricDefault = JSON.parse(info.info).wdfabricDefault;
    state.wddesign = JSON.parse(info.info).wddesign;
    state.wddesignCopy = JSON.parse(info.info).wddesignCopy;
    state.goodsData = JSON.parse(info.info).goodsData;
    // state.sdphase1.style =JSON.parse(info.info).sdphase1.style
    state.clearCacheTdcIds = JSON.parse(info.info).clearCacheTdcIds
    state.is_state = JSON.parse(info.info).is_state
    state.sdphaseType = JSON.parse(info.info).sdphaseType
    state.saveUserData = JSON.parse(info.info).saveUserData
    state.gd_end = JSON.parse(info.info).gd_end
    state.gd_info = JSON.parse(info.info).gd_info
    state.is_step = JSON.parse(info.info).is_step
  },
  // 接口返回500对loading进行处理
  [GLOBAL_FLAG](state, info) {
    state.globalLoading = info
    // console.log(info);
  },
  // 改变加载动画
  [CHANGE_LOADING](state, info) {
    state.fullscreenLoading = info
  },
  // 登陆用户信息
  [RECORD_USERINFO](state, info) {
    state.userInfo = JSON.parse(JSON.stringify(info))
    state.login = true
    localStorage.setItem('userInfo', JSON.stringify(info));
    localStorage.setItem('login', true);
    setStore('state', state);
  },
  // 获取用户信息
  [GET_USERINFO](state, info) {
    if (state.userInfo) {
      return
    }
    if (!state.login) {
      return
    }
    if (state.login && state.userInfo) {
      return state.userInfo
    }
  },
  // 注销用户
  [REMOVE_USERINFO](state, info) {
    state.sdphase2.collideCurrentTechnology1 = {}
    state.clearCacheTdcIds = []
    state.userInfo = null;
    state.login = false;
    localStorage.setItem('userInfo', null);
    localStorage.setItem('login', false);
    setStore('state', state);
  },
  // 展示或者隐藏登陆页面
  [DISPLAYHIDING_LOGININFO](state, info) {
    state.displayhidingLogin = info;
  },
  // 展示或者隐藏登陆页面
  [DISPLAYHIDING_ACCOUNT](state, info) {
    state.displayhidingAccount = info;
  },
  // 重置数据
  [RESET_SDPHASE](state, info) {
    state.threeD = ''//清空3D
    state.order = '',//订单编辑id
    state.sdphase1 = {
      sexData: {},
      category: {},
      style: state.sdphase1.style,
      fabricSupply: {},
      editionType: []
    };
    state.sdphase2 = {
      defaultFabric: {},//设计选择的面料
      design: [],//设计选择的工艺
      // designCopy: [],//设计选择的工艺
      conflict: [],//冲突
      craftworkBound: [],//工艺绑定
      collideCurrentTechnology1: {}
    };
    state.sdphase3 = {
      showItems: [],
      selected_categoryId: false,
      drawerName: {},
      design: []
    };
    state.saveUserData = {//个人信息
      id: undefined,
      phone: undefined,
      name: undefined,
      weight: undefined,
      height: undefined,
      danhao: undefined,
      measureStaff: undefined,
    };
    state.selfMassing = {//自主量体
      tailor: [],
      dressStyle: {},
      specials: []
    };
    state.selfDetermination = {//自主选择
      size: {},
      tailor: []
    };
    state.sdphaseType = '';
    state.wdfabricDefault = {};
    state.wddesign = [];
    state.wddesignCopy = [];
    state.goodsData = {};
    state.editCommodity =  {
      phone: '',
      fullName: '',
      weight: '',
      height: '',
      danhao: '',
      measureStaff: '',
      addStr:''
    };//购物车编辑
    state.clearCacheTdcIds = []
    setStore('state', state);
  },
  // 批量发货选择的订单
  [ADD_DELIVERY](state, info) {
    state.selectOrderList = info;
    setStore('state', state);
  },
  // 订单修改
  [EDIT_ORDER](state, info) {
    if (info.sdphaseType == 2) {
      state.order = {
        id: info.orderId
      };
      state.saveUserData = info.saveUserData;
      state.sdphase1 = info.sdphase1;
      state.sdphase2 = info.sdphase2;
      state.sdphaseType = info.sdphaseType;
      state.selfDetermination = info.selfDetermination;
    } else if (info.sdphaseType == 1) {
      state.order = {
        id: info.orderId
      };
      state.saveUserData = info.saveUserData;
      state.sdphase1 = info.sdphase1;
      state.sdphase2 = info.sdphase2;
      state.sdphaseType = info.sdphaseType;
      state.selfMassing = info.selfMassing;
    }
    setStore('state', state);
  },
  // 添加分类
  [ADD_SEX](state, info) {
    state.sdphase1.sexData = info;
    setStore('state', state);
  },
  // 添加品类
  [ADD_CATEGORY](state, info) {
    state.sdphase1.category = info;
    setStore('state', state);
  },
  // 添加风格
  [ADD_STYLE](state, info) {
    state.sdphase1.style = info;
    if (info&&state.clearCacheTdcIds.indexOf(info.tdcId) == -1) {
      state.clearCacheTdcIds.push(info.tdcId)
    }
    setStore('state', state);
  },
  // 添加面料供应
  [ADD_FABRICSUPPLY](state, info) {
    state.sdphase1.fabricSupply = info;
    setStore('state', state);
  },
  // 添加版型
  [ADD_EDITIONTYPE](state, info) {
    state.sdphase1.editionType = info;
    setStore('state', state);
  },
  // 添加工艺
  [ADD_PROCESSLIST](state, info) {
    state.sdphase1.processList = info;
    setStore('state', state);
  },
  // 改变选择工艺
  [CHANGE_DESIGN](state, info) {
    state.sdphase2.design = info;
    setStore('state', state);
  },
  // 改变选择工艺复制
  // [CHANGE_DESIGNCOPY](state, info) {
  //   state.sdphase2.designCopy = info;
  //   setStore('state', state);
  // },
  // 选择面料
  [CHANGE_DEFAULTFABRIC](state, info) {
    state.sdphase2.defaultFabric = info;
    setStore('state', state);
  },
  // 深度设计tab栏区
  [CONTENT_AREA](state, info) {
    state.sdphase3.showItems = info;
  },
  // 深度设计内容区显示tab栏时不让进行其他操作
  [CONTENT_FLAG](state, info) {
    state.sdphase3.selected_categoryId = info;
  },
  // 深度设计内容区选中的名字
  [DRAWER_NAME](state,info) {
    state.sdphase3.drawerName = info
  },
  // 深度设计左侧列表
  [CONTENT_DESIGN](state,info) {
    state.sdphase3.design = info
  },
  // 改变用户信息
  [ADD_SAVEUSERDATA](state, info) {
    state.saveUserData = info;
    setStore('state', state);
  },
  // 改变选择量体   sdphaseType 双数为 自主选择     单数为 自主量体
  [ADD_SDPHASETYPE](state, info) {
    state.sdphaseType = info;
    setStore('state', state);
  },
  // 自主量体
  [ADD_SELFMASSING](state, info) {
    state.selfMassing = info;
    setStore('state', state);
  },
  // 自主选择
  [ADD_SELFDETERMINATION](state, info) {
    state.selfDetermination = info;
    setStore('state', state);
  },
  // 微定制选择工艺
  [CHANGE_WD_DESIGN](state, info) {
    state.wddesign = info;
    setStore('state', state);
  },
  // 微定制选择面料
  [ADD_WD_FABRICSUPPLY](state, info) {
    state.wdfabricDefault = info;
    setStore('state', state);
  },
  // 微定制选择商品
  [ADD_GOODS](state, info) {
    state.goodsData = info;
    setStore('state', state);
  },
  // 中英文切换
  [CHANGE_LANG](state, info) {
    state.lang = info;
  },
  // 3D 配置
  [CHANGE_3D](state, info) {
    state.threeD = info;
    setStore('state', state);
  },
  // 3D 截图
  [CHANGE_IMG](state, info) {
    state.is_picture = info;
    setStore('state', state);
  },
  // 深度设置 展示 所有的 数据
  [ALL_MSG](state, info) {
    state.is_state = info;
    setStore('state', state);
  },
  [IS_STEP](state, info) {
    state.is_step = info
    setStore('state', state);
  },
  // 高定 结束
  [GD_END](state, info) {
    state.gd_end = info;
    setStore('state', state);
  },
  // 高定 结束信息
  [GD_INFO](state, info) {
    state.gd_info = info;
    setStore('state', state);
  },
  // 冲突 与 关联 存储
  [GD_RELATION](state, info) {
    // state.gd_info = info;
    let { conflict, craftworkBound,design, collideCurrentTechnology1 } = info;
    state.sdphase2.conflict = conflict//冲突
    state.sdphase2.craftworkBound = craftworkBound//关联
    state.sdphase2.design=design
    state.sdphase2.collideCurrentTechnology1 = collideCurrentTechnology1
    setStore('state', state);
  },
  // 购物车编辑
  // editCommodity
  [EDIT_COMMODITY](state,info) {
    state.editCommodity = info
    setStore('state', state);
  },
  // 清除产品的tdcid
  [CLEAR_CACHETDCIDS](state,info) {
    state.clearCacheTdcIds = info
    setStore('state', state);
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js